import { computed } from 'vue';
import {
  AddFieldParam,
  WidgetContainer,
  WidgetItem,
} from '../widgets/WidgetContainer';
import { SearchType } from '../interface/SearchType';

export interface SearchContainerGroup {
  title: string;
  items: WidgetItem<SearchType>[];
}

export class SearchWidgetContainer extends WidgetContainer<void, SearchType> {
  constructor() {
    super('edit', 'search');
  }

  addField(
    id: string,
    title: string,
    widget: SearchType,
    param?: AddFieldParam
  ) {
    super.doAddField(id, title, widget, undefined, param);
  }

  public groups = computed(() => {
    const groups: SearchContainerGroup[] = [];
    Object.values(this.groupMap.value).map((group) => {
      const formGroup: SearchContainerGroup = {
        title: group.title,
        items: [],
      };
      group.items.map((item) => {
        formGroup.items.push(item);
      });
      groups.push(formGroup);
    });
    return groups;
  });
}
